export class QuestionnaireFormatSummary {
  constructor(
    public readonly version: string,
  ) {
  }

  clone() {
    return new QuestionnaireFormatSummary(
      this.version,
    );
  }
}
